

import { createTypes } from 'redux-action-creator';
import { type User } from '../../../types/user';
import { type Action } from '../../types';

export const types: Record<string, string> = createTypes(
  ['LOAD_SUCCESS'],
  'USER',
);

export function receiveUsers(users: User[]): Action<User[]> {
  return {
    type: types.LOAD_SUCCESS,
    response: users,
  };
}
